module.exports = __webpack_public_path__ + "img/commissioned_scanned.d39b5e3e.png";